<div class="industry-container d-flex">
  <!-- Left Tab Menu -->
  <div class="tab-list d-flex flex-column gap-3">
    <button
      *ngFor="let item of items; let i = index"
      class="tab-button d-flex align-items-center gap-2"
      [class.active]="i === selectedIndex"
      (click)="selectTab(i)"
    >
      <!-- <div class="tab-icon"> -->
      <!-- Replace below with icons if needed -->
      <!-- <span class="icon-placeholder">{{ item.subject.charAt(0) }}</span> -->
      <!-- </div> -->
      <span>{{ item.subject }}</span>
    </button>
  </div>

  <!-- Right Panel -->
  <div class="tab-content flex-fill">
    <div class="row align-items-center g-4 h-100">
      <!-- Text Section -->
      <div class="col-12 col-md-6 p-5">
        <h2 class="h4">{{ items[selectedIndex].subject }}</h2>
        <p>{{ items[selectedIndex].description }}</p>
        <button class="btnGlobal--secondary mt-3">Get in Touch →</button>
      </div>

      <!-- Image Section -->
      <div class="col-12 col-md-6 text-end">
        <img
          [src]="items[selectedIndex].image"
          alt="{{ items[selectedIndex].subject }}"
          class="img-fluid rounded shadow-sm"
        />
      </div>
    </div>
  </div>
</div>
